import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t, lang } = useLanguage();
  const isSpanish = lang === 'es';

  return (
    <footer className="bg-zinc-950 border-t border-white/5 py-16 px-6">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <Link to="/" className="text-xl tracking-tighter text-white mb-4 block">
            <span className="font-normal">Mathias</span>
            <span className="font-bold ml-1.5">Deppe</span>
            <span className="text-orange-500">.</span>
          </Link>
          <p className="text-zinc-500 text-sm max-w-xs leading-relaxed">
            {t.footer.desc}
          </p>
        </div>

        <div className="flex flex-col items-center md:items-end text-center md:text-right gap-4">
          <div className="text-zinc-400 text-sm font-medium">
            contact@mdlens.com | Nemesi Valls 42, 08210 Barberà del Vallès, Barcelona
          </div>

          <div className="flex flex-wrap justify-center gap-6">
            <a
              href="https://www.instagram.com/mathiasmazeedeppe/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-zinc-500 hover:text-orange-500 text-xs transition-colors"
            >
              Instagram
            </a>

            <Link
              to="/about"
              className="text-zinc-500 hover:text-orange-500 text-xs transition-colors"
            >
              {isSpanish ? 'Sobre mí' : 'About'}
            </Link>

            <a
              href="mailto:contact@mdlens.com"
              className="text-zinc-500 hover:text-orange-500 text-xs transition-colors"
            >
              {isSpanish ? 'Contacto' : 'Contact'}
            </a>

            <Link
              to="/imprint"
              className="text-zinc-500 hover:text-orange-500 text-xs transition-colors"
            >
              {t.footer.imprint}
            </Link>

            <Link
              to="/privacy"
              className="text-zinc-500 hover:text-orange-500 text-xs transition-colors"
            >
              {t.footer.privacy}
            </Link>

            <Link
              to="/terms"
              className="text-zinc-500 hover:text-orange-500 text-xs transition-colors"
            >
              {isSpanish ? 'Términos de Servicio' : 'Terms of Service'}
            </Link>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto mt-12 pt-8 border-t border-white/5 text-center text-zinc-600 text-[10px] uppercase tracking-widest">
        &copy;{new Date().getFullYear()} Mathias Deppe. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;